export const actionTypes = {
  REQUEST_START: 'DECLARATION_AVAILABLE_YEARS.REQUEST_START',
  REQUEST_SUCCESS: 'DECLARATION_AVAILABLE_YEARS.REQUEST_SUCCESS',
  REQUEST_FAILURE: 'DECLARATION_AVAILABLE_YEARS.REQUEST_FAILURE',
};

export function startRequest(mode) {
  return {
    type: actionTypes.REQUEST_START,
    payload: mode,
  };
}

export function requestSuccess(payload) {
  return {
    type: actionTypes.REQUEST_SUCCESS,
    payload,
  };
}

export function requestFailure(payload) {
  return {
    type: actionTypes.REQUEST_FAILURE,
    payload,
  };
}
